import styled, { css } from "styled-components";

const active = css`
  &.--active {
    transform: translate(0, 0);
    opacity: 1;
  }
`;

export const ModalWrapper = styled.div`
  align-items: center;
  background: linear-gradient(
    to bottom,
    rgba(33, 33, 33, 0.98) 0%,
    rgba(0, 0, 0, 1) 100%
  );
  background-blend-mode: multiply;
  display: flex;
  justify-content: center;
  height: 100vh;
  left: 0;
  opacity: 0;
  position: fixed;
  top: 0;
  transform: translateY(-100vh);
  transition: opacity 400ms, transform 400ms;
  width: 100%;
  will-change: opacity, transform;
  z-index: 999;

  ${active}
`;

export const ModalContainer = styled.section`
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.32);
  max-width: 48rem;
  width: 80%;
`;

export const ModalHeader = styled.div`
  align-items: center;
  background: linear-gradient(to right bottom, #212121 0%, #000000 100%);
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 3px 3px 0 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.16);
  display: flex;
  justify-content: space-between;
  padding: 1.6rem 3.2rem;
`;

export const ModalTitle = styled.h1`
  color: #ffc813;
  font-size: 2.4rem;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
`;

export const ModalTogglerButton = styled.button`
  align-items: center;
  background-color: transparent;
  border: none;
  color: #fff;
  cursor: pointer;
  display: flex;
  font-size: 1.6rem;
  justify-content: center;
  height: 4.8rem;
  outline-color: transparent;
  transition: color 400ms;
  width: 4.8rem;
  will-change: color, transform;

  :hover {
    color: #ededed;
  }
`;

export const ModalBody = styled.div`
  padding: 3.2rem;
`;
